import type { LoadableType } from '@confluence/loadable';
import {
	LoadableActivatable,
	LoadableAfterPaint,
	ActivationTriggerType,
} from '@confluence/loadable';
import { SSR_PARTIAL_COMPONENT } from '@confluence/ssr-utilities/entry-points/ssrPartialSuccess.ts';
import type { AudioButtonProps } from './AudioButton.tsx';

export const AudioButtonLoaderActivatable: LoadableType<AudioButtonProps> = LoadableActivatable({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AudioButton" */ './AudioButton.tsx')).AudioButton,
	triggers: [
		{
			type: ActivationTriggerType.HOVER,
		},
	],
	ssrSuccessCheckName: SSR_PARTIAL_COMPONENT.AudioButton,
});

export const AudioButtonLoaderAfterPaint: LoadableType<AudioButtonProps> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AudioButton" */ './AudioButton.tsx')).AudioButton,
});
